import React from 'react';
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

import axios from "../axios";
import { Files } from "../api/api";

import Dashboard from "../Dashboard";
import {
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";

export default function FileRead() {
  const { id } = useParams<{
    id: string;
  }>();
  const navigation = useNavigate();

  const [data, setData] = useState<Files>({});
  const [update, setUpdate] = useState<boolean>(false);

  useEffect(() => {
    axios.get("/files/" + id).then((res) => {
      setData(res.data);
    });
  }, [id, update]);

  const handleEdit = () => {
    navigation("/files/update/" + id);
  };

  const dateValue = (date: Date | undefined) => {
    if (date !== undefined) {
      return date!.toString().substring(0,19).replace('T', ' ');
    } else {
      return "";
    }
  };

  return (
    <Dashboard title="ファイル管理">
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>{data.id}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>アプリID</TableCell>
            <TableCell>{data.app_id}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>ファイルキー</TableCell>
            <TableCell>{data.file_key}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>ファイルバージョン</TableCell>
            <TableCell>{data.file_version}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>ファイルパス</TableCell>
            <TableCell>{data.file_path}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>ファイルハッシュ</TableCell>
            <TableCell>{data.file_hash}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>作成日時</TableCell>
            <TableCell>{dateValue(data.created_at)}</TableCell>
          </TableRow>
        </TableBody>
        <TableBody>
          <TableRow>
            <TableCell>更新日時</TableCell>
            <TableCell>{dateValue(data.updated_at)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <br/>
      <Grid item xs={12}>
        <Button color="primary" variant="contained" onClick={handleEdit} sx={{ m: 1 }}>
          EDIT
        </Button>
      </Grid>
    </Dashboard>
  );
}
